<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_package.yml" lang="yaml"></i18n>

<template>
  <div class="mt-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">Datos del lote</h3>
      </div>
      <div class="panel-body">
        <div class="space-y-8 divide-y divide-gray-200">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.week") }}
              </dt>
              <dd class="content-data">
                {{ harvested_batch.week }}
              </dd>
            </div>

            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.batch_code") }}
              </dt>
              <dd class="content-data">
                {{ harvested_batch.batch_code }}
              </dd>
            </div>

            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.registered_at") }}
              </dt>
              <dd class="content-data">
                {{ dateFormatter(harvested_batch.registered_at) }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.producer") }}
              </dt>
              <dd class="content-data">
                {{ harvested_batch.producer.producer_code }}
                {{ harvested_batch.producer.fullname }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.crop_field") }}
              </dt>
              <dd class="content-data">
                {{ harvested_batch.crop_field?.name }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.total_weight") }}
              </dt>
              <dd class="content-data">
                {{ numberWithPrecision(harvested_batch.total_weight) }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_package.crop_har_package") }}
              </dt>
              <dd class="content-data">
                {{ harvested_packages }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.crop_type") }}
              </dt>
              <dd class="content-data">
                {{ harvested_batch.crop_type.name }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.crop_variety") }}
              </dt>
              <dd class="content-data">
                {{ harvested_batch.crop_variety.name }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.agro_exporter_process") }}
              </dt>
              <dd class="content-data">
                {{ harvested_batch.agro_exporter_process?.name }} -
                {{ harvested_batch.agro_exporter?.name }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.harvest_team") }}
              </dt>
              <dd class="content-data">
                {{ harvested_batch.harvest_team?.harvest_team_code }} -
                {{ harvested_batch.harvest_team?.foreman }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.packing_line") }}
              </dt>
              <dd class="content-data">
                {{ harvested_batch.packing_line?.name }}
              </dd>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrgProcessPackingHarvestedBatchInfo",
  components: {},
  data() {
    return {};
  },
  props: {
    harvested_batch: {
      required: true
    }
  },
  computed: {
    harvested_packages: function () {
      return this.harvested_batch.harvested_packages
        .map(
          harvested_package =>
            `${harvested_package.number} ${harvested_package.crop_har_package.name}`
        )
        .join(", ");
    }
  }
};
</script>
